import content from './content.json'
import config from '../../../../../config'

export const ThanksPanel = () => {
    return (
        <div className={'thanks-panel'}>
            <span className={'thanks-panel-title'}>{content?.title}</span>
            <span className={'thanks-panel-star'}>{content?.icon}</span>
            <p className={'thanks-panel-text'}>{content?.text}</p>
            <div className={'social-links'}>
                <a
                    className={'social-link linkedin'}
                    href={`https://www.linkedin.com/sharing/share-offsite/?url=https://www.uxray.app${config.root}/`}
                    target="_blank" rel="noopener noreferrer"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 72 72" width="24 ">
                        <g fill="none" fillRule="evenodd">
                            <path
                                d="M62,62 L51.315625,62 L51.315625,43.8021149 C51.315625,38.8127542 49.4197917,36.0245323 45.4707031,36.0245323 C41.1746094,36.0245323 38.9300781,38.9261103 38.9300781,43.8021149 L38.9300781,62 L28.6333333,62 L28.6333333,27.3333333 L38.9300781,27.3333333 L38.9300781,32.0029283 C38.9300781,32.0029283 42.0260417,26.2742151 49.3825521,26.2742151 C56.7356771,26.2742151 62,30.7644705 62,40.051212 L62,62 Z M16.349349,22.7940133 C12.8420573,22.7940133 10,19.9296567 10,16.3970067 C10,12.8643566 12.8420573,10 16.349349,10 C19.8566406,10 22.6970052,12.8643566 22.6970052,16.3970067 C22.6970052,19.9296567 19.8566406,22.7940133 16.349349,22.7940133 Z M11.0325521,62 L21.769401,62 L21.769401,27.3333333 L11.0325521,27.3333333 L11.0325521,62 Z"
                                fill="#FFF"
                            />
                        </g>
                    </svg>
                    {content?.shareBtnText}
                </a>
                <a
                    className={'social-link x'}
                    href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(`https://www.uxray.app${config.root}/`)}`}
                    target="_blank" rel="noopener noreferrer"
                >
                    <svg width="16" height="16" viewBox="0 0 160 163" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M95.2217 69.0194L154.785 0H140.671L88.9516 59.9286L47.6437 0H0L62.4656 90.6226L0 163H14.1155L68.7321 99.7134L112.356 163H160L95.2183 69.0194H95.2217ZM75.8887 91.421L69.5596 82.397L19.2015 10.5924H40.882L81.5216 68.541L87.8507 77.565L140.677 152.889H118.997L75.8887 91.4244V91.421Z"
                            fill="white"/>
                    </svg>
                    {content?.shareBtnText}
                </a>
            </div>
        </div>
    )
}